<p class="example-question">
    {{ question }}
</p>